import zodAttendanceActivityDto from '@/schemas/attendance/zod-AttendanceActivityDto.js';
import { BaseApi } from '@/services/api/base-api.ts';
import { z } from 'zod';
import { PickEnum } from '@/utils/type-helper';
import zodAttendanceActivityAddDto from '@/schemas/attendance/zod-AttendanceActivityAddDto.js';
import zodAttendanceActivityModifyDto from '@/schemas/attendance/zod-AttendanceActivityModifyDto.js';

/**
 * 근태 관리 > 근태 활동
 * SEE: https://neo-flex.corp-dq.nwz.cloud/swagger-ui/index.html?urls.primaryName=2.%20%EA%B7%BC%ED%83%9C%20%EA%B4%80%EB%A6%AC#/
 */

export type AttendanceActivityDto = z.infer<typeof zodAttendanceActivityDto>;
export type AttendanceActivityRequest = z.infer<
  typeof zodAttendanceActivityAddDto
>;
export type AttendanceActivityModifyRequest = z.infer<
  typeof zodAttendanceActivityModifyDto
>;

export type AttendanceAction = PickEnum<AttendanceActivityDto, 'action'>;
export type AttendanceLocation = PickEnum<AttendanceActivityDto, 'location'>;

export class AttendanceActivityApi extends BaseApi {
  constructor() {
    super();
  }

  /** 근태 활동 수정*/
  async modifyAsync(activityModifyRequest: AttendanceActivityModifyRequest) {
    return this.requestAsync({
      schema: zodAttendanceActivityDto,
      method: 'put',
      url: 'attendance/activity',
      payload: activityModifyRequest,
    });
  }

  /** 근태 활동 추가 (출근) */
  async startWorkAsync(location: AttendanceLocation = 'INSIDE') {
    return this.requestAsync({
      schema: zodAttendanceActivityDto,
      method: 'post',
      url: 'attendance/activity/WORK_START',
      query: {
        location,
      },
    });
  }

  /** 근태 활동 추가 */
  async createAsync(activity: AttendanceActivityRequest) {
    return this.requestAsync({
      schema: zodAttendanceActivityDto,
      method: 'post',
      url: 'attendance/activity',
      payload: activity,
    });
  }

  /** 쉬러가기 */
  async startAwayAsync(attendanceId: number) {
    return this.createAsync({
      attendanceId,
      action: 'AWAY_START',
    });
  }

  /* 근무 복귀 */
  async endAwayAsync(
    attendanceId: number,
    location: AttendanceLocation = 'INSIDE'
  ) {
    return this.createAsync({
      attendanceId,
      action: 'AWAY_END',
      location: location,
    });
  }

  /* 근무 재시작 */
  async restartWorkAsync(
    attendanceId: number,
    location: AttendanceLocation = 'INSIDE'
  ) {
    return this.createAsync({
      attendanceId,
      action: 'WORK_START',
      location: location,
    });
  }

  /**
   * 근무 종료
   * @param attendanceId 근태 ID
   * @param comment 근무 코멘트
   */
  async endWorkAsync(
    attendanceId: number,
    comment: string = ''
  ) {
    return this.createAsync({
      attendanceId,
      action: 'WORK_END',
      comment: comment,
    });
  }

  /** 근태 활동 목록 조회 */
  async listByAttendanceIdAsync(attendanceId: number) {
    return this.requestAsync({
      schema: z.array(zodAttendanceActivityDto), // 배열
      url: `attendance/${attendanceId}/activities`,
    });
  }

  /* 근태 활동 조회 */
  /*async getAsync(activityId: number) {
                                    return this.request({
                                      schema: zodAttendanceActivityDto,
                                      url: `attendance/activity/${activityId}`,
                                    });
                                  }*/

  /* 근태 활동 삭제 */
  async removeAsync(activityId: number) {
    return this.requestAsync({
      schema: z.boolean(),
      method: 'delete',
      url: `attendance/activity/${activityId}`,
    });
  }
}
